<!--
상품 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>팝업수정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <vue-ctk-date-time-picker
                    class="uk-margin-small-bottom"
                    disable-time
                    range-mode
                    without-range-shortcut
                    format="YYYY-MM-DD"
                    label="게시기간을 선택하세요"
                    v-model="date_range"
                ></vue-ctk-date-time-picker>

                <app-input-ex
                    class="uk-margin-small-bottom"
                    type="text"
                    input-size="small"

                    name="title"
                    v-model="inputs.title"
                    label="제목"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder="제목을 작성하세요"
                > </app-input-ex>

                <app-input-ex
                    class="uk-margin-small-bottom"
                    type="textarea"
                    input-size="small"
                    :textarea-rows="10"

                    name="content"
                    v-model="inputs.content"
                    label="팝업내용"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder="내용을 작성하세요"
                > </app-input-ex>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 팝업ID
                popup_id: null,

                // 입력값 object
                inputs: {
                    type: 1, // 1 : TEXT
                    title: null,
                    content: null,
                },

                // 기간
                date_range: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param popup_id 팝업ID
             */
            form(popup_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/popups/' + popup_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    let popup = response.popup;

                    // id 저장
                    this.popup_id = popup.id;

                    // 팝업 설정
                    _.assignIn(this.inputs, {
                        type: popup.type,
                        title: popup.title,
                        content: popup.content,
                    });

                    // 기간설정
                    this.date_range = {
                        start: popup.started_at,
                        end: popup.ended_at,
                    };

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {
                // 기간선택 검증
                if (typeof this.date_range !== 'object'
                    || (! this.date_range.start)
                    || (! this.date_range.end)
                ) {
                    alert('게시기간을 선택하세요');
                    return ;
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/popups/' + this.popup_id,
                    data: _.merge({
                        '_token': this.csrfToken,
                        'started_at': this.date_range.start,
                        'ended_at': this.date_range.end,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>